import { render, staticRenderFns } from "./milestone-form-plan.vue?vue&type=template&id=56bf03a4&"
import script from "./milestone-form-plan.vue?vue&type=script&lang=ts&"
export * from "./milestone-form-plan.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-form-plan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports